"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderDesktop = void 0;
const React = require("react");
const theme_1 = require("../modules/theme");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const react_native_1 = require("react-native");
const layout_1 = require("../modules/layout");
class HeaderDesktop extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                container: {
                    backgroundColor: theme.backgroundColor3,
                    height: HeaderDesktop.height,
                    flexDirection: 'row',
                    alignItems: 'center',
                    shadowOpacity: 0.6,
                    shadowRadius: 20,
                    shadowColor: theme.shadowColor1
                },
                title: {
                    color: theme.textColor4,
                    fontSize: 24,
                    fontFamily: theme.fontFamily3
                },
                greeting: {
                    color: theme.textColor4,
                    fontSize: 18,
                    fontFamily: theme.fontFamily2,
                    marginLeft: 'auto',
                    marginRight: 20
                },
                button: {
                    padding: (0, layout_1.isTablet)() ? 14 : 10
                },
                counterContainer: {
                    position: 'absolute',
                    backgroundColor: theme.counterBackgroundColor,
                    height: (0, layout_1.isTablet)() ? 20 : 15,
                    width: (0, layout_1.isTablet)() ? 20 : 15,
                    top: 5,
                    left: 18,
                    borderRadius: 50
                },
                counterText: {
                    textAlign: 'center',
                    color: theme.counterTextColor,
                    fontSize: (0, layout_1.isTablet)() ? 15 : 10
                }
            });
            return styles;
        };
        this.renderRightButton = (button) => {
            const styles = this.getStyles();
            const theme = (0, theme_1.getTheme)();
            const icon = (React.createElement(React.Fragment, null,
                React.createElement(FontAwesome_1.default, { nativeID: button.nativeID, name: button.icon, size: (0, layout_1.isTablet)() ? 30 : 20, color: button.disabled ? theme.textColor1 : theme.textColor4, 
                    // @ts-ignore : The component uses a different version of typing
                    style: button.buttonStyle }),
                button.counter ? (React.createElement(react_native_1.View, { style: styles.counterContainer },
                    React.createElement(react_native_1.Text, { nativeID: `${button.nativeID}-counter`, style: styles.counterText }, button.counter))) : null));
            const style = [styles.button];
            if (button.disabled) {
                return React.createElement(react_native_1.View, { style: style }, icon);
            }
            return (React.createElement(react_native_1.TouchableOpacity, { onPress: button.onPress, style: style }, icon));
        };
    }
    render() {
        const { logo, title, greeting, rightButton, headerStyle } = this.props;
        const styles = this.getStyles();
        return (React.createElement(react_native_1.View, { style: [styles.container, headerStyle] },
            logo(),
            title && React.createElement(react_native_1.Text, { style: styles.title }, title),
            greeting && (React.createElement(react_native_1.Text, { nativeID: "app-greeting-message", style: [styles.greeting, greeting.style] }, greeting.message)),
            rightButton && this.renderRightButton(rightButton)));
    }
}
exports.HeaderDesktop = HeaderDesktop;
HeaderDesktop.height = 60;
